export const handlePrint = () => {
  // Save current scroll position
  const scrollPos = window.scrollY;

  // Add print-specific classes
  document.body.classList.add('printing');

  // Print
  window.print();

  // Remove print-specific classes
  document.body.classList.remove('printing');

  // Restore scroll position
  window.scrollTo(0, scrollPos);
};

export const setupPrintStyles = () => {
  // Add print media listener
  window.matchMedia('print').addListener((mql) => {
    if (mql.matches) {
      document.body.classList.add('printing');
    } else {
      document.body.classList.remove('printing');
    }
  });
};